import { Controller } from "stimulus"
import * as echarts from 'echarts';
import Rails from "@rails/ujs";
import { halfLetGraphs } from "./../mixins/half_let_graphs";

import $ from 'jquery';

require("select2/dist/css/select2")

import Select2 from "select2"


export default class extends Controller {
  static targets = ['graphs', "startAt", "endAt", 'table']
  connect() {
    $('.league-search').select2();
    $(".league-search").on('select2:select', function () {
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });
    halfLetGraphs(this)
    if (document.getElementById('half_size_graph').attributes._echarts_instance_) {
      return
    }
    var dates = [],
      totals = [],
      wins = [],
      ties = [],
      fails = []
    fetch("/match_results/half_left_graph.json?clazz=size")
      .then(response => response.text())
      .then(res => {
        var rs = JSON.parse(res)
        console.log(rs)
        rs.data.forEach(data => {
          dates.push(data[0])
          totals.push(data[1])
          wins.push(data[2])
          ties.push(data[3])
          fails.push(data[4])
        });
        this.loadGraph(dates, totals, wins, ties, fails, echarts.init(document.getElementById('half_size_graph')))
        this.goalGraph(rs.goals, rs.no_goals)
        this.winsGraph(rs.wins, rs.ties, rs.fails)
      })
  }

  search() {
    var dates = [],
      totals = [],
      wins = [],
      ties = [],
      fails = []
    fetch("/match_results/half_left_graph.json?clazz=size&start_at=" + this.startAtTarget.value + "&end_at=" + this.endAtTarget.value + "&league=" + $('.league-search').val())
      .then(response => response.text())
      .then(res => {
        var rs = JSON.parse(res)
        console.log(rs)
        rs.data.forEach(data => {
          dates.push(data[0])
          totals.push(data[1])
          wins.push(data[2])
          ties.push(data[3])
          fails.push(data[4])
        });
        this.loadGraph(dates, totals, wins, ties, fails, echarts.init(document.getElementById('half_size_graph')))
        this.goalGraph(rs.goals, rs.no_goals)
        this.winsGraph(rs.wins, rs.ties, rs.fails)
        this.loadData(rs.total, rs.goals, rs.no_goals, rs.wins, rs.ties, rs.fails)
      })
  }
  loadData(half_let_total, half_let_gotal_total, half_let_ungotal_total, half_let_win_total, half_let_tie_total, half_let_fail_total ) {
    return this.tableTarget.innerHTML = `<td class="px-6 py-4 text-center">
            ${half_let_gotal_total}
            </td>
            <td class="px-6 py-4 text-center">
             <span class="text-red-600 text-bold">${(half_let_gotal_total > 0 ? half_let_gotal_total / parseFloat(half_let_total) * 100 : 0).toFixed(1) }%</span>
             (${half_let_gotal_total})
            </td>
            <td class="px-6 py-4 text-center">
              ${(half_let_gotal_total > 0 ? half_let_ungotal_total / parseFloat(half_let_total) * 100 : 0).toFixed(1)}%
              (${half_let_ungotal_total})
            </td>
            <td class="px-6 py-4 text-center">
             <span class="text-red-600 text-bold">${(half_let_gotal_total > 0 ? half_let_win_total / parseFloat(half_let_total) * 100 : 0).toFixed(1) }%</span>
             (${half_let_win_total})
            </td>
            <td class="px-6 py-4 text-center">
             ${(half_let_gotal_total > 0 ? half_let_tie_total / parseFloat(half_let_total) * 100 : 0).toFixed(1)}%
              (${half_let_tie_total})
            </td>
            <td class="px-6 py-4 text-center">
             ${(half_let_gotal_total > 0 ? half_let_fail_total / parseFloat(half_let_total) * 100 : 0).toFixed(1)}%
              (${half_let_fail_total})
            </td>
            `
  }

}